import React from 'react';
import { Container, Row, Col, Card, ListGroup, Badge, Button } from 'react-bootstrap';
import logoImage from "../../assets/images/DailyTaskLogo.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-gradient text-white pt-5 pb-4">
      <Container>
        {/* Top row: logo + social */}
        <Row className="align-items-center mb-4">
          <Col md={6} className="mb-3 mb-md-0">
            <div className="d-flex align-items-center">
              <span
                className="me-2 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: 30,
                  height: 30,
                  background: "rgba(255,255,255,0.5)",
                  borderRadius:10
                }}
              >
                <img src={logoImage} alt="Logo" height="40" className="me-0" />
              </span>
              <h5 className="mb-0">Daily Post Hub</h5>
            </div>
          </Col>
          <Col md={6} className="text-md-end">
            <a href="#" className="text-white text-decoration-none me-3">
              <i className="bi bi-twitter fs-5" />
            </a>
            <a href="#" className="text-white text-decoration-none me-3">
              <i className="bi bi-facebook fs-5" />
            </a>
            <a href="#" className="text-white text-decoration-none me-3">
              <i className="bi bi-linkedin fs-5" />
            </a>
            <a href="#" className="text-white text-decoration-none">
              <i className="bi bi-youtube fs-5" />
            </a>
          </Col>
        </Row>

        {/* Links rows */}
        <Row className="gy-4">
          <Col md={3}>
            <h6 className="text-uppercase fw-semibold mb-3">Product</h6>
            <ul className="list-unstyled mb-0">
              <li><a href="/" className="text-white text-decoration-none">Features</a></li>
              <li><a href="#" className="text-white text-decoration-none">Pricing</a></li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="text-uppercase fw-semibold mb-3">Company</h6>
            <ul className="list-unstyled mb-0">
              <li><a href="/contactus" className="text-white text-decoration-none">Contact us</a></li>
              <li><a href="/aboutus" className="text-white text-decoration-none">About us</a></li>
             
             
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="text-uppercase fw-semibold mb-3">Other Links</h6>
            <ul className="list-unstyled mb-0">
              <li><a href="#" className="text-white text-decoration-none">Privacy policy</a></li>
              <li><a href="#" className="text-white text-decoration-none">Terms and conditions</a></li>
            </ul>
          </Col>

          <Col md={3}>
            <h6 className="text-uppercase fw-semibold mb-3">More</h6>
            <ul className="list-unstyled mb-0">
              <li><a href="/contactus" className="text-white text-decoration-none">Book your free demo</a></li>
               <li><a href="#" className="text-white text-decoration-none">Blog</a></li>
            </ul>
          </Col>
        </Row>

        {/* Copyright */}
        <Row className="mt-5">
          <Col className="small text-white-50">
            © 2025 dailyposthub.com
          </Col>
        </Row>
      </Container>

      {/* Inline styles as requested */}
      <style jsx="true">{`
        .footer-gradient {
          background: linear-gradient(135deg, #20c997 0%, #0d6efd 100%);
        }
        .footer-gradient a:hover {
          text-decoration: underline;
        }
      `}</style>
    </footer>
  );
}

export default Footer
